import React, { Suspense } from "react";
import { Helmet } from "react-helmet-async";
import Card from "@mui/material/Card";

// Presentation page sections
const Counter = React.lazy(() => import("pages/Homepage/sections/Counter"));
const InformationHome = React.lazy(() => import("pages/Homepage/sections/InformationHome"));
const TestimonialsHome = React.lazy(() => import("pages/Homepage/sections/TestimonialsHome"));
const FAQSection = React.lazy(() => import("pages/Homepage/sections/FAQSection"));
const HeroSection = React.lazy(() => import("pages/Homepage/sections/HeroSection"));
// const BreakPointSection = React.lazy(() => import("pages/Homepage/sections/BreakPointSection"));
const ServicesSection = React.lazy(() => import("pages/Homepage/sections/Services"));
const StepsSection = React.lazy(() => import("pages/Homepage/sections/StepsSections"));
// const BlogsSection = React.lazy(() => import("pages/Homepage/sections/BlogsSections")); momentan ramane ascunsa pana apar alte modificari
// const BeforeAfterGallery = React.lazy(() => import("pages/Homepage/sections/BeforeAfterGallery"));

function Homepage() {
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <Helmet>
                <title>Doral Cleaning - Servicii profesionale de curatenie</title>
                <link rel="canonical" href="https://doral-cleaning.ro/" />
                <meta
                    name="description"
                    content="Echipă de curățenie verificată, cu asigurare profesională și zero costuri ascunse. Curățăm spații comerciale, industriale și rezidențiale. Eficiență garantată!"
                />
                <script type="application/ld+json">
                    {`
                    {
                      "@context": "https://schema.org",
                      "@type": "LocalBusiness",
                      "name": "Doral Cleaning - Servicii profesionale de curatenie",
                      "image": "",
                      "@id": "",
                      "url": "",
                      "telephone": "0730 407 322",
                      "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "Calea Șerban Vodă 82, Sector 4, 040213 București",
                        "addressLocality": "",
                        "postalCode": "",
                        "addressCountry": ""
                      },
                      "geo": {
                        "@type": "GeoCoordinates",
                        "latitude": 44.4202372718721,
                        "longitude": 26.10209372955662
                      }  
                    }
                    `}
                </script>
            </Helmet>
            <HeroSection />
            <Card
                sx={{
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
                        rgba(white.main, 0.8),
                    backdropFilter: "saturate(200%) blur(30px)",
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <Counter />
                <TestimonialsHome />
                {/* <BreakPointSection /> */}
                <InformationHome />
                <ServicesSection />
                <StepsSection />
                {/* <BeforeAfterGallery /> */}
                {/* <BlogsSection /> */}
                <FAQSection />
            </Card>
        </Suspense>
    );
}

export default Homepage;
